import {Component, inject} from '@angular/core'
import {MatCard, MatCardAvatar, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card'
import {MatIcon} from '@angular/material/icon'
import {RouterLink} from '@angular/router'
import {ConfigService, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../../../environments/environment'
import {RoleHelper} from '../../services/role-helper'

@Component({
  selector: 'spb-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardAvatar,
    MatIcon,
    MatCardTitle,
    RouterLink,
    MatCardContent,
    LoginComponent
  ]
})
export class HomeComponent {
  public readonly helper = inject(RoleHelper)
  protected readonly environment = environment
  protected readonly configService = inject(ConfigService)
}
